import { render, staticRenderFns } from "./EditAggrConfigForm.vue?vue&type=template&id=64258665&"
import script from "./EditAggrConfigForm.vue?vue&type=script&lang=js&"
export * from "./EditAggrConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports